import { render, staticRenderFns } from "./magycorpTechnologiesSC.vue?vue&type=template&id=bc17c988&scoped=true&"
import script from "./magycorpTechnologiesSC.vue?vue&type=script&lang=js&"
export * from "./magycorpTechnologiesSC.vue?vue&type=script&lang=js&"
import style0 from "./magycorpTechnologiesSC.vue?vue&type=style&index=0&id=bc17c988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc17c988",
  null
  
)

export default component.exports